(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["audio-player"] && !Shopify.designMode) return;
  try {
    class AudioPlayer extends HTMLElement {
    connectedCallback() {
      this._audio = this.querySelector('audio');
      this._btn = this.querySelector('.audio-player__btn');
      this._wave = this.querySelector('.audio-player__wave');
      this._btn.addEventListener('click', () => this._toggle());
      this._audio.addEventListener('play', () => this._setPlaying(true));
      this._audio.addEventListener('pause', () => this._setPlaying(false));
      this._audio.addEventListener('ended', () => this._setPlaying(false));
    }

    _toggle() {
      if (this._audio.paused) {
        this._audio.play();
      } else {
        this._audio.pause();
      }
    }

    _setPlaying(playing) {
      this._wave.hidden = !playing;
      this._btn.setAttribute('aria-label', playing ? 'Pause audio' : 'Play audio');
    }
  }

  if (!customElements.get('audio-player')) {
    customElements.define('audio-player', AudioPlayer);
  }
  } catch(e) { console.error(e); }
})();

})();
